import React from 'react';
import { useTranslation } from "react-i18next";
import ErrorAlert from "./ErrorAlert"
import Tooltip from './Tooltip';

const TextInput = (props) => {
  const { t } = useTranslation();
  const tooltipBody = props.tooltip ? t(props.tooltip).replace(/\n/g, '<br />') : '';
  const tooltipPlace = window.lang === 'en' ? 'left' : 'right';

  return (
    <div className={"form-group " + (props.error ? "not-valid" : "")} style={{ 'position': 'relative' }}>
      {props.tooltip &&
        <span data-tooltip-id={props.name}
          data-tooltip-html={tooltipBody}
          data-tooltip-place={tooltipPlace}
          data-tooltip-offset={10}
          style={{ 'position': 'absolute', 'z-index': '999', 'right': window.lang === 'en' ? '0' : null, 'left': window.lang !== 'en' ? '0' : null, 'top': '2rem', 'cursor': 'pointer', 'display': 'inline-flex', 'line-height': '1' }}>
          <i
            className={"fa fa-question-circle" + (window.lang !== 'en' ? " fa-flip-horizontal" : '')}
            aria-hidden="true">
          </i>
        </span>}
      <label
        className="input-label"
        style={{
          visibility: props.value ? "visible" : "hidden",
        }}
      >
        {t(props.label)}
      </label>
      <input
        type={props.type}
        name={props.name}
        className="form-control"
        value={props.value}
        onChange={props.handleChange}
        onBlur={props.handleBlur}
        placeholder={t(props.label)}
        id={props.id}
      />
      {props.hint && <small>{t(props.hint)}</small>}
      {props.error &&
        <ErrorAlert error={props.error} errorType={props.errorType ? props.errorType : ""} />
      }
      {props.errorType && <div style={{ display: 'none' }} className={props.errorType}>{props.error}</div>}
      {props.tooltip && <Tooltip id={props.name} place={tooltipPlace} />}

    </div>
  )
};

export default TextInput;
